// extracted by mini-css-extract-plugin
export default {"ResultsWrapper":"Results_ResultsWrapper__Kv1hZ","TextWrapper":"Results_TextWrapper__hgqav","Result":"Results_Result__tLrRB","Label":"Results_Label__pOTEz"};